import { UploadScreen } from "../../features/upload";

/** FS-02 내 작품 올리기 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/upload */
export default function UploadPage() {
  return <UploadScreen />;
}
